import React from 'react';
import PropTypes from 'prop-types';
import styles from './CircleLoader.css';
import classnames from 'classnames';

const CircleLoader = ({ children }) => {
  return (
    <div className={styles.loadingIcon}>
      <div className={styles.mask}>{children}</div>
      <div className={classnames(styles.circle, styles.left)}>
        <div className={styles.fill} />
      </div>
      <div className={classnames(styles.circle, styles.right)}>
        <div className={styles.fill} />
      </div>
    </div>
  );
};

CircleLoader.displayName = 'CircleLoader';

CircleLoader.propTypes = {
  children: PropTypes.node,
};

export default CircleLoader;
